import { render, staticRenderFns } from "./Vulnerability.vue?vue&type=template&id=2da5733a"
import script from "./Vulnerability.vue?vue&type=script&lang=js"
export * from "./Vulnerability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports